import React from 'react';
import PropTypes from 'prop-types';

import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

function PasswordTextField({ value, onChange, onKeyUp, onFocus, onBlur, id, startAdornment }) {

    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <TextField
            id={id}
            name={id}
            label="Mot de passe"
            fullWidth
            type={showPassword ? 'text' : 'password'}
            value={value}
            onChange={onChange}
            onKeyUp={onKeyUp}
            onFocus={onFocus}
            onBlur={onBlur}

            InputProps={{
                startAdornment: startAdornment,
                endAdornment: (
                    <InputAdornment position="end">

                        <IconButton
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                        >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>

                    </InputAdornment>)
            }}
        />
    );
}

PasswordTextField.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    startAdornment: PropTypes.node
};


export default PasswordTextField;